/**
 * 业务配置
 * */
// const SettingEnv = require('@/setting.env');
const env = process.env.NODE_ENV;

const Setting = {
    /**
     * 基础配置
     * */
    // 路由模式，可选值为 history 或 hash
    routerMode: 'hash',
    // 应用的基路径
    routerBase: '/',
    // 页面切换时，是否显示模拟的进度条
    showProgressBar: true,
    // 接口请求地址
    // apiBaseURL: env === 'development' ? '/public' : ((SettingEnv.type === 'test') ? (SettingEnv.testUrl) : (SettingEnv.productionUrl)),
    apiBaseURL:   env === 'development' ? '/public' : process.env.VUE_APP_BASE_URL,
    // 接口请求返回错误时，弹窗的持续时间，单位：秒
    modalDuration: 5,
    // 接口请求返回错误时，弹窗的类型，可选值为 Message 或 Notice
    errorModalType: 'Message',
    // Cookies 默认保存时间，单位：天
    cookiesExpires: 1,
    // 数据存储方式 可选值 sessionStorage或 localStorage
    StorageType: localStorage,
    //文件上传地址
    uploadUrl: (process.env.VUE_APP_BASE_URL) + 'webapi/api/UploadFile',
    //文件浏览地址
    fileUrl: (process.env.VUE_APP_BASE_URL) + 'webapi/'
};

export default Setting;